<template>
    <div>
        <Head :title="title + ' Booking'" />

        <Banner />

        <CompleteProfileModal />

        <div class="min-h-screen bg-gray-100 relative">
            <MainNavigation />

            <!-- Page Heading -->
            <header v-if="$slots.header" class="bg-white shadow">
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <slot name="header" />
                </div>
            </header>

            <!-- Page Content -->
            <main class="pb-[5rem]">
                <slot />
            </main>

            <footer class="flex gap-3 w-full justify-center py-6 absolute bottom-0 font-bold">
                <Link href="/terms">Terms & Conditions</Link>
                -
                <a href="https://thenerdhut.co.uk/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        </div>
    </div>
</template>

<script setup>
    import { Head, Link } from "@inertiajs/vue3";
    import Banner from "../../InertiaComponents/Banner.vue";
    import MainNavigation from "./MainNavigation.vue";
    import CompleteProfileModal from "../../Components/CompleteProfileModal.vue";

    defineProps({
        title: String,
    });

    const goToStore = () => {
        window.location = "https://thenerdhut.co.uk";
    };
</script>
